<div class="migrate-confirm">
  <p class="intro">
    Migrate all payment accounts, tokens, transactions, invoices and history from
    <strong>{{ sourceName }}</strong>
    <span *ngIf="source?.companyAccountNumber"> ({{ source.companyAccountNumber }})</span>
    into a surviving customer. The source customer will then be
    <strong>permanently purged</strong>.
  </p>

  <mat-form-field appearance="outline" class="surviving-picker">
    <mat-label>Surviving customer</mat-label>
    <mat-select
      [(ngModel)]="selectedSurvivingId"
      (selectionChange)="onSurvivingSelected()"
      panelClass="migrate-surviving-panel"
    >
      <mat-option *ngFor="let c of candidates" [value]="c.id">
        {{ c.displayName }}
        <span *ngIf="c.companyAccountNumber"> — {{ c.companyAccountNumber }}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div *ngIf="previewLoading" class="preview-loading">
    <mat-spinner diameter="24"></mat-spinner>
    <span>Calculating records to move…</span>
  </div>

  <div *ngIf="previewError" class="preview-error">{{ previewError }}</div>

  <div *ngIf="preview && !previewLoading" class="preview-panel">
    <h4>Records that will move into <strong>{{ survivingName }}</strong></h4>

    <table *ngIf="movingRows.length" class="preview-table">
      <tbody>
        <tr *ngFor="let row of movingRows">
          <td class="label">{{ row.label }}</td>
          <td class="count">{{ row.count }}</td>
        </tr>
        <tr class="total">
          <td class="label">Total records</td>
          <td class="count">{{ preview.totalRecords }}</td>
        </tr>
      </tbody>
    </table>

    <p *ngIf="!movingRows.length" class="no-records">
      No related records — only the customer record itself will be removed.
    </p>

    <p class="net-result">
      After migration, <strong>{{ survivingName }}</strong> will own the records above, and
      <strong>{{ sourceName }}</strong>
      <span *ngIf="source?.companyAccountNumber"> ({{ source.companyAccountNumber }})</span>
      will be <strong>permanently purged</strong>. This cannot be undone.
    </p>
  </div>

  <p *ngIf="!selectedSurvivingId" class="hint">
    Select a surviving customer to preview what will move.
  </p>
</div>
